import {
  CREATE_CONSIGNMENT_ORDER_BILLING,
  DELETE_CONSIGNMENT_ORDER_BILLING,
  GET_CONSIGNMENT_ORDER_BILLING_BY_CONSIGNMENT_ORDER_ID,
  GET_CONSIGNMENT_ORDER_BILLING_BY_ID,
  GET_CONSIGNMENT_ORDER_BILLINGS,
  UPDATE_CONSIGNMENT_ORDER_BILLING,
} from '../types';

const initialState = {
  consignmentOrderBillings: [],
  consignmentOrderBillingById: {},
  consignmentOrderBillingDelete: null,
  consignmentOrderByConsigmentOrder: [],
};

export default function ConsignmentOrderBilling(state = initialState, action) {
  switch (action.type) {
    case CREATE_CONSIGNMENT_ORDER_BILLING:
      return {
        ...state,
        consignmentOrderBillings: [
          ...state.consignmentOrderBillings,
          action.payload,
        ],
      };
    case GET_CONSIGNMENT_ORDER_BILLINGS:
      return {
        ...state,
        consignmentOrderBillings: action.payload,
      };
    case GET_CONSIGNMENT_ORDER_BILLING_BY_ID:
      return {
        ...state,
        consignmentOrderBillingById: action.payload,
      };
    case GET_CONSIGNMENT_ORDER_BILLING_BY_CONSIGNMENT_ORDER_ID:
      return {
        ...state,
        consignmentOrderByConsigmentOrder: action.payload,
      };
    case UPDATE_CONSIGNMENT_ORDER_BILLING:
      return {
        ...state,
        consignmentOrderBillings: state.consignmentOrderBillings.map(
          (billing) =>
            billing.id === action.payload.id ? action.payload : billing
        ),
      };
    case DELETE_CONSIGNMENT_ORDER_BILLING:
      return {
        ...state,
        consignmentOrderBillings: state.consignmentOrderBillings.map(
          (billing) =>
            billing.id === action.payload.id ? action.payload : billing
        ),
      };
    default:
      return state;
  }
}
